// import Allianz from "../assets/logos/allianz.png";
// import Bbva from "../assets/logos/bbva.png";
// import Bolivar from "../assets/logos/bolivar.png";
// import Chevyseguros from "../assets/logos/chevyseguro.png";
// import Colpatria from "../assets/logos/colpatria.png";
// import Confianza from "../assets/logos/confianza.png";
// import Equidad from "../assets/logos/equidad.png";
// import Estado from "../assets/logos/estado.png";
// import Hdi from "../assets/logos/hdi.png";
// import Liberty from "../assets/logos/liberty.png";
// import Mapfre from "../assets/logos/mapfre.png";
// import Mundial from "../assets/logos/mundial.png";
// import Positiva from "../assets/logos/positiva.png";
// import Previsora from "../assets/logos/previsora.png";
// import SBS from "../assets/logos/sbs.png";
// import Solidaria from "../assets/logos/solidaria.png";
// import Sura from "../assets/logos/sura.png";
// import Zurich from "../assets/logos/zurich.png";

const BASE_URL = "https://clientes.co.agentemotor.com/logos/";

export const Images = {
  allianz: BASE_URL + "allianz.png",
  bbva: BASE_URL + "bbva.png",
  bolivar: BASE_URL + "bolivar.png",
  chevyseguros: BASE_URL + "chevyseguro.png",
  colpatria: BASE_URL + "colpatria.png",
  confianza: BASE_URL + "confianza.png",
  equidad: BASE_URL + "equidad.png",
  estado: BASE_URL + "estado.png",
  hdi: BASE_URL + "hdi.png",
  liberty: BASE_URL + "liberty.png",
  mapfre: BASE_URL + "mapfre.png",
  mundial: BASE_URL + "mundial.png",
  positiva: BASE_URL + "positiva.png",
  previsora: BASE_URL + "previsora.png",
  sbs: BASE_URL + "sbs.png",
  solidaria: BASE_URL + "solidaria.png",
  sura: BASE_URL + "sura.png",
  zurich: BASE_URL + "zurich.png",
  qualitas: BASE_URL + "qualitas.png",
};
